import {
	Component,
	EventEmitter,
	Inject,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild
} from "@angular/core";
import {CustomEqualitySet} from "custom-equality-set";
import {Money} from "money";
import {CartService} from "purchasing-shared/cart.service";
import {Aircraft} from "../aircraft";
import {AvdbBundleCartItem} from "../avdb-bundle-cart-item";
import {AvdbCartItem} from "../avdb-cart-item";
import {Message} from "../common/message";
import {Device} from "../device";
import {DeviceModel} from "../device-model";
import {DeviceService} from "../device.service";
import {AvdbPricingAircraftBundle} from "./avdb-pricing-aircraft-bundle";
import {AvdbPricingBundle} from "./avdb-pricing-bundle";
import {AvdbPricingBundlePackage} from "./avdb-pricing-bundle-package";
import {AvdbPricingChartPreference} from "./avdb-pricing-chart-preference";
import {AvdbPricingDeviceBundle} from "./avdb-pricing-device-bundle";
import {AvdbPricingMapRegionID} from "./avdb-pricing-map-region";
import {AvdbPricingProduct} from "./avdb-pricing-product";
import {AvdbPricingProductType} from "./avdb-pricing-product-type";
import {AvdbPricingResponse} from "./avdb-pricing-response";
import {KeepShoppingModalComponent} from "./keep-shopping-modal.component";
import {CartItem} from "../../purchasing/cart/cart-item";
import {Observable} from 'rxjs';
import {AvdbSubscription} from "../avdb-subscription";
import {AvdbSubscriptionService} from "../avdb-subscription.service";
import {contextPath, fgURL} from "site";

const FLITECHARTS_AVDB_TYPE_ID = 5;

@Component({
	selector: "bundle-recommendation",
	template: `

		<!---------- NOTE EXPLAINING RECOMMENDATIONS TAB ---------->
		<p class="segmentedtab_info">
			<i class="fa fa-info-circle fa-lg"></i>
			The following recommendations are based on your selected aircraft and devices, map regions, and preferences
			(shown below if applicable).
			To see all available bundles and database options, select the Bundles, Annual Subscriptions, or Single
			Updates tabs above.
		</p>

		<div class="databasepricing_selection_sections">

			<!---------- SELECT A CHART PREFERENCE ---------->
			<div *ngIf="shouldShowChartPreference" class="databasepricing_selection_section">
				<h3>Terminal Charts Preference: <small class="databasepricing_headingsubtext">(Select one)</small></h3>

				<ul class="databasepricing_selection_list">
					<li *ngFor="let chartPreference of chartPreferenceOptions"
						(click)="selectChartPreference(chartPreference)"
						[class.active]="isChartPreferenceSelected(chartPreference)">
						{{ chartPreference.title }}
					</li>
				</ul>
			</div>
		</div>

		<!---------- BUNDLE PACKAGES ---------->
		<div class="databasepricing_recommendedbundles_list" *ngIf="shouldShowBundlePackages()">
			<div *ngIf="bundlePackages.length > 0; else noBundlePackages">
				<ng-container *ngFor="let bundlePackage of bundlePackages">
					<div class="databasepricing_row">
						<div class="databasepricing_row_column">

							<!---------- BUNDLE PACKAGE - INCLUDED BUNDLES ---------->
							<div class="databasepricing_recommendedbundles_info">
								<h4 *ngFor="let bundle of bundlePackage.bundles"
									class="databasepricing_recommendedbundles_info_bundle">
									{{ bundle.description }}
									<span *ngIf="getDeviceNameForBundle(bundle)"
										  class="databasepricing_recommendedbundles_info_device">
										- {{ getDeviceNameForBundle(bundle) }}
									</span>
									<span *ngIf="bundlePackage.shouldDisplayIndividualPrices"
										  class="databasepricing_recommendedbundles_info_cost">
										- {{ bundle.price | money }}
									</span>
								</h4>
								<div *ngFor="let device of bundlePackage.getDevicesCoveredByAdditionalProducts()">
									<h4 *ngFor="let product of bundlePackage.getAdditionalProductsForDevice(device)"
										class="databasepricing_recommendedbundles_info_bundle">
										{{ product.productType.name }} -
										<span *ngFor="let series of product.series; let i = index;">
											{{ series.region.displayName }}{{ (i < product.series.length - 1) ? ", " : "" }}
										</span>
										<span class="databasepricing_recommendedbundles_info_device">
											- {{ device.name }}
										</span>
										<span class="databasepricing_recommendedbundles_info_cost">
											- {{ product.price | money }}
										</span>
									</h4>
								</div>
								<a class="databasepricing_recommendedbundles_coveragelink"
								   (click)="coverageModal.open(bundlePackage)">
									View Coverage Details
								</a>
								<ng-container *ngFor="let message of getCoverageMessages(bundlePackage)">
									<avdb-message [message]="message"></avdb-message>
								</ng-container>
							</div>

						</div>
						<div class="databasepricing_row_column">

							<!---------- BUNDLE PACKAGE - PRICE AND SELECT BUTTON ---------->
							<div class="databasepricing_row_group">
								<div class="databasepricing_row_price" *ngIf="activeSubscriptionsLoaded && (bundlePackage | flyIsBundleActiveForAircraftOrDevice:  activeSubscriptions) as subscriptionStatus">
									<div *ngIf="!subscriptionStatus.isPurchased">
										{{ bundlePackage.price | money }}
									</div>
								</div>
								<div>
									<ng-container
										*ngIf="activeSubscriptionsLoaded && (bundlePackage | flyIsBundleActiveForAircraftOrDevice:  activeSubscriptions) as subscriptionStatus">
										<div class="active-subscription" *ngIf="subscriptionStatus.isPurchased; else addToCartButton" >
											<div class="redeem-subscription" *ngIf="!subscriptionStatus.isRedeemed">
												<span class="unredeemed-subscription">You have an unredeemed subscription.</span>
												<a target="_blank" href="{{navigateToDetails(subscriptionStatus.isAircraftBundle)}}"
														class="button button-primary">
													Redeem Now
												</a>
											</div>
											<div class="manage-subscription" *ngIf="subscriptionStatus.isRedeemed">
												<span *ngIf="subscriptionStatus.autoRenewActive">You have an active subscription that <strong>automatically renews</strong> on {{ subscriptionStatus.renewalDate }}.</span>
												<span *ngIf="!subscriptionStatus.autoRenewActive">You have an active subscription that <strong>expires</strong> on {{ subscriptionStatus.endDate }}.</span>
												<a target="_blank" href="{{fgURL + 'subscriptions/databases/'}}"
												   class="button button-primary">
													Manage Subscription
												</a>
											</div>
										</div>
									</ng-container>
									<ng-template #addToCartButton>
										<div>
											<ng-container
												*ngIf="loadingAddToCart && (bundlePackage | flyIsBundlePackageAlreadyInCartForAircraft: selectedAircraft: currentCart)  || (bundlePackage | flyIsBundlePackageAlreadyInCartForAircraft: selectedAircraft: currentCart); else addToCart">
												<i class="fa fa-check"></i>
												<span class="bold-text">
											ADDED TO CART
										</span>
											</ng-container>
											<ng-template #addToCart>
												<button class="button button-secondary"
														(click)="addBundlePackageToCart(bundlePackage)">
													Add to Cart
												</button>
											</ng-template>
										</div>
									</ng-template>
								</div>
							</div>

						</div>
					</div>
				</ng-container>
			</div>

			<ng-template #noBundlePackages>
				<div>
					<p>There are no bundles available that match your selected criteria.</p>
				</div>
			</ng-template>
		</div>

		<bundle-package-coverage-detail #coverageModal
										[devices]="allSelectedDevices"
										[bundleToDevicesMap]="filteredBundleToCoveredDevicesMap"
										[partKeyProductMap]="partKeyProductMap"></bundle-package-coverage-detail>

		<keep-shopping-modal (continueShopping)="updateCart()"></keep-shopping-modal>
	`,
})
export class BundleRecommendationComponent implements OnInit, OnChanges {
	readonly contextPath = contextPath;
	readonly fgURL = fgURL;

	@Input() selectedAircraft: Aircraft;
	@Input() currentCart: CartItem[] | null = null;
	@Input() selectedPortable: Device;
	@Input() partKeyProductMap: Map<string, AvdbPricingProduct>;
	@Input() avdbPricingResponse: AvdbPricingResponse;
	@Input() selectedMapRegions: Set<AvdbPricingMapRegionID>;
	@Output() bundleAddedToCart = new EventEmitter();
	@Output() continueShopping = new EventEmitter();

	@ViewChild(KeepShoppingModalComponent) keepShoppingModal: KeepShoppingModalComponent;

	// Device Models
	deviceModels: Array<DeviceModel> = [];

	// Chart Preference
	chartPreferenceOptions: Array<AvdbPricingChartPreference> = AvdbPricingChartPreference.options;
	shouldShowChartPreference = true;
	selectedChartPreference = AvdbPricingChartPreference.GARMIN_FLITECHARTS;

	// Filtered Bundles
	filteredBundleToCoveredDevicesMap = new Map<AvdbPricingBundle, Array<Device>>();

	// Bundle Packages
	_bundlePackages = new CustomEqualitySet<AvdbPricingBundlePackage>();
	numAllBundlePackages: number;
	numHighestRankedBundlePackages: number;

	loadingAddToCart: boolean = false;

	activeSubscriptions: AvdbSubscription[];

	activeSubscriptionsLoaded: boolean = false;

	bundleRecommendationCart: CartItem[] | null = null;

	// Bundles with these skus should not be recommended
	skusToNotRecommend: string[];

	constructor(
		@Inject("skusToNotRecommend") skusToNotRecommend: string[],
		private cartService: CartService,
		private deviceService: DeviceService,
		private avdbSubscriptionService: AvdbSubscriptionService) {
		this.skusToNotRecommend = skusToNotRecommend;
	}

	ngOnInit() {
		const aircraftSubscriptions$ = (this.selectedAircraft == null || this.selectedAircraft.masterAircraftUuid == null) ?
			Observable.of([] as AvdbSubscription[]) :
			this.avdbSubscriptionService
				.getAvdbSubscriptions(null, this.selectedAircraft.masterAircraftUuid, null, false, true)
				.catch(() => Observable.of([] as AvdbSubscription[]));


		const portableSubscriptions$ = (this.selectedPortable == null || this.selectedPortable.displaySerial == null) ?
			Observable.of([] as AvdbSubscription[]) :
			this.avdbSubscriptionService
				.getAvdbSubscriptions(null, null, this.selectedPortable.displaySerial, false, true)
				.catch(() => Observable.of([] as AvdbSubscription[]));

		Observable.forkJoin(
			this.deviceService.getDeviceModels(),
			aircraftSubscriptions$,
			portableSubscriptions$
		).subscribe(([deviceModels, aircraftSubscriptions, portableSubscriptions]) => {
			this.deviceModels = deviceModels;
			this.activeSubscriptions = aircraftSubscriptions.concat(portableSubscriptions);
			this.activeSubscriptionsLoaded = true;
		})

		this.refreshCurrentCart();
	}

	ngOnChanges(changes: SimpleChanges) {
		if ("avdbPricingResponse" in changes || "selectedMapRegions" in changes) {
			let aircraft = this.selectedAircraft;
			let selectedMapRegions = this.selectedMapRegions;
			let deviceModels = this.deviceModels;
			let bundles = this.getAllBundles().filter(bundle => {
				return this.filterBundlesByHelicopterFixedWingEligibility(bundle, aircraft, deviceModels) &&
					this.isAnySelectedMapRegionCoveredByBundle(bundle, selectedMapRegions);
			});
			this.shouldShowChartPreference = this.calculateShouldShowChartPreference(bundles);
			this.numAllBundlePackages = 0;
			this.numHighestRankedBundlePackages = 0;
			this.calculateBundlePackages();
		}

		if ("currentCart" in changes) {
			this.refreshCurrentCart();
		}
	}

	// TODO: Duplicated from DatabasePricingComponent
	get allSelectedDevices(): Array<Device> {
		let devices: Array<Device> = [];
		if (this.selectedAircraft != null)
			devices.push(...this.selectedAircraft.devices);
		if (this.selectedPortable != null)
			devices.push(this.selectedPortable);
		return devices;
	}

	private populateFilteredBundleToCoveredDevicesMap() {
		this.filteredBundleToCoveredDevicesMap = new Map<AvdbPricingBundle, Array<Device>>();
		for (let bundle of this.getFilteredBundles()) {
			if (bundle instanceof AvdbPricingAircraftBundle) {
				const devices: Array<Device> = [];
				for (let deviceModel of bundle.qualifyingDeviceModels) {
					const registeredDevices = this.allSelectedDevices.filter(device => device.modelID === deviceModel.modelID);
					for (let registeredDevice of registeredDevices) {
						if (!devices.find(device => device.id === registeredDevice.id)) {
							devices.push(registeredDevice);
						}
					}
				}
				this.filteredBundleToCoveredDevicesMap.set(bundle, devices);
			} else {
				const device = this.allSelectedDevices.find(device => device.id === (bundle as AvdbPricingDeviceBundle).deviceID);
				if (device) {
					this.filteredBundleToCoveredDevicesMap.set(bundle, [device]);
				}
			}
		}
	}

	private isAnySelectedMapRegionCoveredByBundle(bundle: AvdbPricingBundle, selectedMapRegions: Set<AvdbPricingMapRegionID>): boolean {
		const selectedIDs = Array.from(selectedMapRegions.values());
		if (selectedIDs.length === 0)
			return true;

		return selectedIDs.some(id => bundle.isMapRegionSupported(id));
	}

	// ====================================================================================================
	// Aircraft Bundles (OnePaks and PilotPaks)
	// ====================================================================================================

	private getAllAircraftBundles(): Array<AvdbPricingAircraftBundle> {
		return this.avdbPricingResponse.aircraftBundles;
	}

	// ====================================================================================================
	// Device Bundles
	// ====================================================================================================

	private getAllDeviceBundles(): Array<AvdbPricingDeviceBundle> {
		const deviceBundles: Array<AvdbPricingDeviceBundle> = [];
		for (let device of this.avdbPricingResponse.devices) {
			deviceBundles.push(...device.bundles);
		}
		return deviceBundles;
	}

	// ====================================================================================================
	// Chart Preference
	// ====================================================================================================

	private calculateShouldShowChartPreference(bundles: Array<AvdbPricingBundle>) {

		const startChartPreference = this.selectedChartPreference;
		this.selectChartPreference(AvdbPricingChartPreference.NONE);
		const bundlePackagesWithPreference = this.bundlePackages;
		this.selectChartPreference(AvdbPricingChartPreference.GARMIN_FLITECHARTS);
		const bundlesPackagesWithoutPreference = this.bundlePackages;
		this.selectChartPreference(startChartPreference);

		let bundlePackagesDiffered: boolean = false;
		if (bundlePackagesWithPreference.length == bundlesPackagesWithoutPreference.length) {
			for (let i = 0; i < bundlePackagesWithPreference.length && !bundlePackagesDiffered; i++) {
				const bundlesWithPreference = Array.from(bundlePackagesWithPreference[i].bundles);
				const bundlesWithoutPreference = Array.from(bundlesPackagesWithoutPreference[i].bundles);
				if (bundlesWithPreference.length != bundlesWithoutPreference.length) {
					bundlePackagesDiffered = true;
				} else {
					const bundlesWithoutPreferencePartKeys = bundlesWithoutPreference.map(bundle => bundle.partKey);
					const bundlesWithPreferencePartKeys = bundlesWithPreference.map(bundle => bundle.partKey);
					for (let j = 0; j < bundlesWithPreferencePartKeys.length; j++) {
						if (bundlesWithoutPreferencePartKeys[j] != bundlesWithPreferencePartKeys[j]) {
							bundlePackagesDiffered = true;
						}
					}
				}
			}
		} else {
			bundlePackagesDiffered = true;
		}

		if (!bundlePackagesDiffered) {
			return false;
		}

		let includes = false;
		let doesNotInclude = false;

		// >= 1 bundle includes FliteCharts && >= 1 bundle does not include FliteCharts
		return _.some(bundles, (bundle) => {
			includes = includes || this.doesBundleIncludeFliteCharts(bundle);
			doesNotInclude = doesNotInclude || !this.doesBundleIncludeFliteCharts(bundle);
			return includes && doesNotInclude;
		});
	}

	selectChartPreference(chartPreference: AvdbPricingChartPreference) {
		if (chartPreference !== this.selectedChartPreference) {
			this.selectedChartPreference = chartPreference;
			this.calculateBundlePackages();
		}
	}

	isChartPreferenceSelected(chartPreference: AvdbPricingChartPreference): boolean {
		return this.selectedChartPreference === chartPreference;
	}

	// ====================================================================================================
	// Bundle Packages
	// ====================================================================================================

	shouldShowBundlePackages(): boolean {
		return !!(this.avdbPricingResponse &&
			(this.selectedAircraft || this.selectedPortable) &&
			this.selectedMapRegions.size > 0 &&
			((this.shouldShowChartPreference) ? this.selectedChartPreference : true));
	}

	private calculateBundlePackages() {
		if (this.shouldShowBundlePackages()) {
			this.populateFilteredBundleToCoveredDevicesMap();
			let filteredBundles = this.getFilteredBundles();
			this._bundlePackages = new CustomEqualitySet<AvdbPricingBundlePackage>();

			for (let bundle of filteredBundles) {
				let initPackage = new AvdbPricingBundlePackage(new CustomEqualitySet<AvdbPricingBundle>([bundle]));
				let emptyPackage = new AvdbPricingBundlePackage(new CustomEqualitySet<AvdbPricingBundle>([]));
				this.addBundlesToBundlePackage(filteredBundles, initPackage, emptyPackage);
			}

			this._bundlePackages.forEach(bundlePackage => {
				this.addAdditionalProductsToBundlePackage(bundlePackage);
				this.increaseBundlePackageRankForSelectedMapRegionsCoveredAndChartChoice(bundlePackage);
				this.calculateValueForBundlePackage(bundlePackage);
			});
		}
	}

	get bundlePackages(): Array<AvdbPricingBundlePackage> {
		if (this._bundlePackages.size === 0)
			return [];

		let bundlePackages = _.sortByOrder(Array.from(this._bundlePackages),
			[bp => bp.rank, bp => bp.price.value],
			["desc", "asc"]);

		this.numAllBundlePackages = bundlePackages.length;

		const highestRank = bundlePackages[0].rank;

		bundlePackages = bundlePackages
			.filter(bp => bp.rank === highestRank);


		const topLevelOnePakOptionExists: boolean = bundlePackages.some((bp) =>
			bp.bundles.size == 1 && Array.from(bp.bundles).some((bundle) => bundle.bundleType == AvdbPricingBundle.BUNDLE_TYPE_ONEPAK)
		);

		if (topLevelOnePakOptionExists) {
			bundlePackages = bundlePackages.filter((bp) =>
				Array.from(bp.bundles).every((bundle) => bundle.bundleType != AvdbPricingBundle.BUNDLE_TYPE_PILOTPAK)
			);
		} else {
			const lowerLevelOnePakOptionExists: boolean = bundlePackages.some((bp) =>
				Array.from(bp.bundles).some((bundle) => bundle.bundleType == AvdbPricingBundle.BUNDLE_TYPE_ONEPAK)
			);

			if (lowerLevelOnePakOptionExists) {
				bundlePackages = bundlePackages.filter((bp) =>
					bp.bundles.size > 1 && Array.from(bp.bundles).every((bundle) => bundle.bundleType != AvdbPricingBundle.BUNDLE_TYPE_PILOTPAK)
				);
			}
		}

		const lowestPrice = bundlePackages[0].price.value;
		bundlePackages = bundlePackages.filter((bp) => bp.price.value == lowestPrice);

		this.numHighestRankedBundlePackages = bundlePackages.length;

		return bundlePackages;
	}

	/**
	 * This method is called recursively to keep adding bundles to a bundle package
	 * as long as there is no overlap in devices covered by each of the bundles.
	 */
	private addBundlesToBundlePackage(filteredBundles: Array<AvdbPricingBundle>, bundlePackage: AvdbPricingBundlePackage, previousPackage: AvdbPricingBundlePackage) {
		if (bundlePackage.bundles.size === previousPackage.bundles.size) {
			return;
		}

		let nonOverlappingBundles = this.filterBundlesForNoOverlappingDeviceCoverageWithBundlePackage(filteredBundles, bundlePackage);

		if (nonOverlappingBundles.length > 0) {
			for (let nonOverlappingBundle of nonOverlappingBundles) {
				// Recursive call
				const bundles = new CustomEqualitySet<AvdbPricingBundle>(bundlePackage.bundles);
				bundles.add(nonOverlappingBundle);
				this.addBundlesToBundlePackage(filteredBundles, new AvdbPricingBundlePackage(bundles), bundlePackage);
			}
		} else {
			// Once the bundle package is full, add it to the main list.
			this._bundlePackages.add(bundlePackage);
		}
	}

	private filterBundlesForNoOverlappingDeviceCoverageWithBundlePackage(bundles: Array<AvdbPricingBundle>, bundlePackage: AvdbPricingBundlePackage) {
		return bundles.filter(bundle => (_.intersection(this.getDevicesCoveredByBundle(bundle), this.getAllDevicesCoveredByBundlePackage(bundlePackage)).length === 0));
	}

	/**
	 * If there are any devices not covered by bundles in this bundle package, we can consider
	 * adding individual database subscriptions for these devices to provide full coverage.
	 *
	 * NOTE: We must be able to narrow down the number of product options to exactly 1
	 * subscription product for each AVDB type for a given device.
	 */
	private addAdditionalProductsToBundlePackage(bundlePackage: AvdbPricingBundlePackage) {
		const devicesNotCovered = this.getDevicesNotCoveredByBundlePackage(bundlePackage);
		for (let device of devicesNotCovered) {
			const additionalProducts = this.getAdditionalProductsForDevice(device);
			if (additionalProducts)
				bundlePackage.additionalProducts.set(device, additionalProducts);
		}
	}

	private getAdditionalProductsForDevice(device: Device): CustomEqualitySet<AvdbPricingProduct> {
		const additionalProducts = new CustomEqualitySet<AvdbPricingProduct>();
		if (device) {
			const pricingDevice = this.avdbPricingResponse.devices.find(d => d.id === device.id);
			if (pricingDevice) {
				for (let productType of pricingDevice.avdbProductTypes) {
					const product = this.getAdditionalProductForProductType(productType);
					if (product)
						additionalProducts.add(product);
					else
						return null;
				}
			}
		}
		return additionalProducts;
	}

	private getAdditionalProductForProductType(productType: AvdbPricingProductType): AvdbPricingProduct {
		const selectedMapRegions = Array.from(this.selectedMapRegions.values());
		const productsWithMapCoverage = productType.products.filter(product => {
			return product.coversMapRegions(selectedMapRegions, false);
		});

		if (productsWithMapCoverage.length === 0)
			return null;
		else if (productsWithMapCoverage.length === 1)
			return productsWithMapCoverage[0];
		else {
			const subscriptionProducts = productsWithMapCoverage.filter(product => product.maxNumberOfIssues > 1);
			if (subscriptionProducts.length === 1)
				return subscriptionProducts[0];
			else
				return null;
		}
	}

	/**
	 * Returns all selected devices that are covered by the provided bundlePackage whether they have partial coverage or full coverage for the selected regions.
	 */
	private getAllDevicesCoveredByBundlePackage(bundlePackage: AvdbPricingBundlePackage): Array<Device> {
		const devicesCovered = new CustomEqualitySet<Device>();

		for (let bundle of Array.from(bundlePackage.bundles)) {
			for (let device of this.getDevicesCoveredByBundle(bundle)) {
				devicesCovered.add(device);
			}
		}

		for (let device of Array.from(bundlePackage.additionalProducts.keys())) {
			devicesCovered.add(device);
		}

		return Array.from(devicesCovered);
	}

	/**
	 * Returns selected devices that have coverage by the provided bundlePackage for some but not all regions selected.
	 */
	private getDevicesPartiallyCoveredByBundlePackage(bundlePackage: AvdbPricingBundlePackage): Array<Device> {
		const devicesPartiallyCovered = new CustomEqualitySet<Device>();
		const devicesFullyCovered = new CustomEqualitySet<Device>();

		for (let bundle of Array.from(bundlePackage.bundles)) {
			for (let device of this.getDevicesCoveredByBundle(bundle)) {
				if (!Array.from(this.selectedMapRegions).every((region) => bundle.isMapRegionSupported(region))) {
					devicesPartiallyCovered.add(device);
				}
			}
		}

		for (let bundle of Array.from(bundlePackage.bundles)) {
			for (let device of this.getDevicesCoveredByBundle(bundle)) {
				if (Array.from(this.selectedMapRegions).every((region) => bundle.isMapRegionSupported(region))) {
					devicesFullyCovered.add(device);
				}
			}
		}

		return _.difference(Array.from(devicesPartiallyCovered), Array.from(devicesFullyCovered));
	}

	/*
	 * Returns selected devices that are not covered by the provided bundle.
	 */
	private getDevicesNotCoveredByBundlePackage(bundlePackage: AvdbPricingBundlePackage): Array<Device> {
		const devicesCovered = this.getAllDevicesCoveredByBundlePackage(bundlePackage);
		return _.difference(this.allSelectedDevices, devicesCovered);
	}

	private increaseBundlePackageRankForSelectedMapRegionsCoveredAndChartChoice(bundlePackage: AvdbPricingBundlePackage) {
		const selectedMapRegionIDs = Array.from(this.selectedMapRegions.values());
		for (let device of this.allSelectedDevices) {
			const bundle = bundlePackage.getBundleThatCoversDevice(device);
			if (bundle) {
				for (let selectedMapRegionID of selectedMapRegionIDs) {
					if (bundle.isMapRegionSupported(selectedMapRegionID)) {
						bundlePackage.increaseRank(AvdbPricingBundlePackage.RANK_INCREASE_FOR_MAP_COVERAGE_REGION);
					}
				}

				if ((this.selectedChartPreference === AvdbPricingChartPreference.GARMIN_FLITECHARTS)) {
					if (bundle.avdbTypesForDeviceModelID(device.modelID).map((type) => type.id).includes(FLITECHARTS_AVDB_TYPE_ID)) {
						bundlePackage.increaseRank(0.1);
					}
				}
			}
			if (bundlePackage.additionalProducts.get(device)) {
				selectedMapRegionIDs.forEach(() => bundlePackage.increaseRank(AvdbPricingBundlePackage.RANK_INCREASE_FOR_MAP_COVERAGE_REGION));
			}
		}
	}

	private calculateValueForBundlePackage(bundlePackage: AvdbPricingBundlePackage) {
		const values: Array<Money> = [];

		for (let bundle of Array.from(bundlePackage.bundles)) {
			const value: Money = this.getValueOfAllHighestPricedProductsIncludedInBundle(bundle);
			if (!value)
				return;
			else
				values.push(value);
		}

		for (let products of Array.from(bundlePackage.additionalProducts.values())) {
			for (let product of Array.from(products)) {
				if (!product.price)
					return;
				else
					values.push(product.price);
			}
		}

		bundlePackage.value = Money.sum(values);
	}

	getCoverageMessages(bundlePackage: AvdbPricingBundlePackage) {
		let messages: Array<Message> = [];

		let avdbTypes = bundlePackage.allAvdbTypes;
		let avdbTypeNames = Array.from(avdbTypes).map(t => t.name).join(", ");
		messages.push(Message.success(`Includes ${avdbTypeNames}`));

		const duplicateDevices = this.selectedAircraft != null ?
			new Set(
				this.selectedAircraft.devices.map(d => d.name).sort().filter((device, currentIndex, devices) =>
					device == devices[currentIndex + 1]
				)
			) :
			new Set();

		const devicesPartiallyCovered = this.getDevicesPartiallyCoveredByBundlePackage(bundlePackage);

		// getAllDevices covered returns devices whether they have full coverage or partial coverage.
		// You can get devices fully covered by getting the difference of all covered devices and partially covered devices.
		let devicesFullyCovered = _.difference(this.getAllDevicesCoveredByBundlePackage(bundlePackage), devicesPartiallyCovered);
		let devicesFullyCoveredNames = devicesFullyCovered.map(d => (duplicateDevices.has(d.name) ? d.name + ' (' + d.displaySerial + ')' : d.name)).join(", ");
		if (devicesFullyCoveredNames.length > 0) {
			messages.push(Message.success(`Covers ${devicesFullyCoveredNames}`));
		}

		let devicesPartiallyCoveredNames = devicesPartiallyCovered.map(d => (duplicateDevices.has(d.name) ? d.name + ' (' + d.displaySerial + ')' : d.name)).join(", ");
		if (devicesPartiallyCoveredNames.length > 0) {
			messages.push(Message.warning(`Does not cover all selected regions for ${devicesPartiallyCoveredNames}`));
		}

		let devicesNotCovered = this.getDevicesNotCoveredByBundlePackage(bundlePackage);
		if (devicesNotCovered.length > 0) {
			let devicesNotCoveredNames = devicesNotCovered.map(d => (duplicateDevices.has(d.name) ? d.name + ' (' + d.displaySerial + ')' : d.name)).join(", ");
			messages.push(Message.warning(`Does not cover ${devicesNotCoveredNames}`));
		}

		return messages;
	}

	getDeviceNameForBundle(bundle: AvdbPricingBundle): string {
		if (bundle instanceof AvdbPricingDeviceBundle) {
			const deviceID = (bundle as AvdbPricingDeviceBundle).deviceID;
			const device = this.allSelectedDevices.find(device => device.id === deviceID);
			return (device) ? device.name : undefined;
		} else {
			return undefined;
		}
	}

	// ====================================================================================================
	// Bundles
	// ====================================================================================================

	private getAllBundles(): Array<AvdbPricingBundle> {
		return [...this.getAllAircraftBundles(), ...this.getAllDeviceBundles()];
	}

	private getFilteredBundles(): Array<AvdbPricingBundle> {
		return this.filterBundles(
			this.getAllBundles(),
			this.selectedAircraft,
			this.selectedMapRegions,
			this.selectedChartPreference,
			this.deviceModels);
	}

	private filterBundles(
		bundles: Array<AvdbPricingBundle>,
		aircraft: Aircraft,
		mapRegions: Set<AvdbPricingMapRegionID>,
		chartPreference: AvdbPricingChartPreference,
		deviceModels: Array<DeviceModel>): Array<AvdbPricingBundle> {

		let filteredBundles = bundles.filter(bundle => {
			return this.filterBundlesByHelicopterFixedWingEligibility(bundle, aircraft, deviceModels) &&
				this.isAnySelectedMapRegionCoveredByBundle(bundle, mapRegions) &&
				this.doesBundleMatchSelectedChartPreference(bundle, chartPreference) &&
				!this.skusToNotRecommend.includes(bundle.partKey);
		});

		// If the selected aircraft is a helicopter then we want to prefer helicopter only bundles.
		// If there are no helicopter only bundles then we want to recommend non-helicopter bundles.
		// This makes it imperative that we only do this filter after we have done the region, chart
		// preference, and other filters.
		const isHelicopterOnlyBundleAvailable = this.selectedAircraft != null &&
			this.selectedAircraft.isRotorcraft &&
			filteredBundles.some((bundle) => bundle.helicopterEligible && !bundle.fixedWingEligible);

		if (isHelicopterOnlyBundleAvailable) {
			filteredBundles = filteredBundles.filter((bundle) => bundle.helicopterEligible && !bundle.fixedWingEligible);
		}

		return filteredBundles;
	}

	private filterBundlesByHelicopterFixedWingEligibility(bundle: AvdbPricingBundle,
														  selectedAircraft: Aircraft,
														  deviceModels: Array<DeviceModel>): Boolean {
		if (bundle.helicopterEligible == null || bundle.fixedWingEligible == null) {
			return true;
		}

		if (bundle instanceof AvdbPricingAircraftBundle) {
			return (selectedAircraft && selectedAircraft.isRotorcraft) ? bundle.helicopterEligible : bundle.fixedWingEligible;
		} else {

			let deviceModelID = (bundle as AvdbPricingDeviceBundle).deviceModelID;
			const deviceModel = deviceModels ? deviceModels.find(deviceModel => deviceModel.id === deviceModelID) : null;
			let isDeviceBundleForAnAircraftDevice = deviceModel && deviceModel.portable === false;

			if (isDeviceBundleForAnAircraftDevice)
				return (selectedAircraft && selectedAircraft.isRotorcraft) ? bundle.helicopterEligible : bundle.fixedWingEligible;
			else
				return true;
		}
	}

	private doesBundleMatchSelectedChartPreference(bundle: AvdbPricingBundle, selectedChartPreference: AvdbPricingChartPreference): boolean {
		if (!selectedChartPreference || selectedChartPreference === AvdbPricingChartPreference.NONE)
			return true;

		if (this.doesBundleIncludeFliteCharts(bundle)) {
			return (selectedChartPreference === AvdbPricingChartPreference.GARMIN_FLITECHARTS);
		} else {
			if (this.doesAnyDeviceCoveredByBundleSupportFliteCharts(bundle)) {
				return (selectedChartPreference !== AvdbPricingChartPreference.GARMIN_FLITECHARTS);
			} else {
				return true;
			}
		}
	}

	private doesBundleIncludeFliteCharts(bundle: AvdbPricingBundle): boolean {
		if (bundle instanceof AvdbPricingAircraftBundle) {
			for (let deviceModel of (bundle as AvdbPricingAircraftBundle).qualifyingDeviceModels) {
				if (deviceModel.deviceModelAvdbTypes.find(avdbType => avdbType.id === FLITECHARTS_AVDB_TYPE_ID)) {
					return true;
				}
			}
			return false;
		} else {
			return !!(bundle as AvdbPricingDeviceBundle).avdbTypes.find(avdbType => avdbType.id === FLITECHARTS_AVDB_TYPE_ID);
		}
	}

	private doesAnyDeviceCoveredByBundleSupportFliteCharts(bundle: AvdbPricingBundle): boolean {
		for (let device of this.getDevicesCoveredByBundle(bundle)) {
			if (device.avdbTypes.find(avdbType => avdbType.id === FLITECHARTS_AVDB_TYPE_ID)) {
				return true;
			}
		}
		return false;
	}

	private getDevicesCoveredByBundle(bundle: AvdbPricingBundle): Array<Device> {
		const devices = this.filteredBundleToCoveredDevicesMap.get(bundle);
		return (devices) ? devices : [];
	}

	private getValueOfAllHighestPricedProductsIncludedInBundle(bundle: AvdbPricingBundle): Money {
		let prices: Array<Money> = [];

		if (bundle instanceof AvdbPricingAircraftBundle) {
			for (let deviceModel of (bundle as AvdbPricingAircraftBundle).qualifyingDeviceModels) {
				for (let avdbType of deviceModel.deviceModelAvdbTypes) {
					const highestPrice: Money = this.getHighestPricedProductOption(avdbType.productOptions);
					if (!highestPrice) {
						// If we don't have complete pricing information, return null;
						return null;
					} else {
						const devices = this.allSelectedDevices.filter(device => device.modelID === deviceModel.modelID);
						devices.forEach(() => prices.push(highestPrice));
					}
				}
			}
		} else {
			for (let avdbType of (bundle as AvdbPricingDeviceBundle).avdbTypes) {
				const highestPrice: Money = this.getHighestPricedProductOption(avdbType.productOptions);
				if (!highestPrice) {
					// If we don't have complete pricing information, return null;
					return null;
				} else {
					prices.push(highestPrice);
				}
			}
		}

		return Money.sum(prices);
	}

	private getHighestPricedProductOption(productOptions: Array<string>): Money {
		let highestPrice: Money;
		for (let partKey of productOptions) {
			const product = this.partKeyProductMap.get(partKey);
			if (!product || !product.price) {
				// If we don't have complete pricing information, return null;
				return null;
			} else {
				if (!highestPrice) {
					highestPrice = product.price;
				} else if (product.price.value > highestPrice.value) {
					highestPrice = product.price;
				}
			}
		}
		return highestPrice;
	}

	// ====================================================================================================
	// Cart
	// ====================================================================================================

	addBundlePackageToCart(bundlePackage: AvdbPricingBundlePackage) {
		this.loadingAddToCart = true;
		let itemsToAdd: CartItem[] = [];
		for (let bundle of Array.from(bundlePackage.bundles)) {
			if (bundle instanceof AvdbPricingAircraftBundle) {
				const aircraft = this.selectedAircraft;
				const cartItem = new AvdbBundleCartItem({bundle, aircraft});
				itemsToAdd.push(cartItem);
			} else {
				const device = this.allSelectedDevices.find(d => d.id === (bundle as AvdbPricingDeviceBundle).deviceID);
				const cartItem = new AvdbBundleCartItem({bundle, device});
				itemsToAdd.push(cartItem);
			}
		}

		for (let device of Array.from(bundlePackage.additionalProducts.keys())) {
			for (let product of Array.from(bundlePackage.additionalProducts.get(device))) {
				const cartItem = new AvdbCartItem({device, product});
				itemsToAdd.push(cartItem);
			}
		}

		Observable.forkJoin(itemsToAdd.map(item => this.cartService.addItem(item))).subscribe(_ => {
			itemsToAdd.map(item => this.keepShoppingModal.addModalItem(item));
			this.loadingAddToCart = false;
			this.keepShoppingModal.open();
		});
	}

	private refreshCurrentCart() {
		this.bundleRecommendationCart = this.currentCart;
	}

	updateCart() {
		this.continueShopping.emit();
		this.bundleAddedToCart.emit();
	}

	navigateToDetails(isAircraft: boolean): string {
		const devicesList = `${this.contextPath}/devices/list`;
		//Neither of these `if` statements are actually used on the page.
		// This stack is just cursed and these checks prevent NPEs which break the entire page.
		if (isAircraft && this.selectedAircraft == null) {
			return devicesList;
		}
		if (!isAircraft && this.selectedPortable == null) {
			return devicesList;
		}
		const pathToUse = (isAircraft) ? '/devices/aircraft/' : '/devices/details/';
		const idToUse = (isAircraft) ? this.selectedAircraft.id : this.selectedPortable.id;
		return `${this.contextPath}${pathToUse}${idToUse}`;
	}
}
